import { render, staticRenderFns } from "./ProductManagementView.vue?vue&type=template&id=5e55a90f"
import script from "./ProductManagementView.vue?vue&type=script&lang=js"
export * from "./ProductManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports